import { render, staticRenderFns } from "./MainNavCart.vue?vue&type=template&id=754c3e35&scoped=true&"
import script from "./MainNavCart.vue?vue&type=script&lang=js&"
export * from "./MainNavCart.vue?vue&type=script&lang=js&"
import style0 from "./MainNavCart.vue?vue&type=style&index=0&id=754c3e35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c3e35",
  null
  
)

export default component.exports